function isIOS() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

function isMobile() {
    return isIOS() || /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

// eslint-disable-next-line import/prefer-default-export
export const lsDeviceHelpers = {
    isIOS,
    isMobile,
};
